// src/App.tsx
import { Switch, Route } from 'wouter';
import { queryClient } from './lib/queryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/toaster';
import { UserLayout } from './layouts/user.layout';
import { UserRoutes } from './components/user-routes';
import { TokenHandler } from './components/auth/token-handler';
import * as Sentry from '@sentry/react';
import { useTrackLocationChange } from './hooks/use-track-location-change';
import { useTrackButtons } from './hooks/use-track-buttons';

if (import.meta.env.MODE === 'production' && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_COMMIT_SHORT_SHA,
    sendDefaultPii: true,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/home\.quizplease\.ru\/api/],
    // Session Replay
    replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
process.env.NODE_ENV;

function Router() {
  useTrackLocationChange();
  useTrackButtons();

  return (
    <Switch>
      <Route>
        <UserLayout>
          <UserRoutes />
        </UserLayout>
      </Route>
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TokenHandler />
      <Router />
      <Toaster />
    </QueryClientProvider>
  );
}

export default App;
